import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import store from './store'
import firebase from 'firebase'
import '@firebase/firestore'

firebase.initializeApp({
  apiKey: "AIzaSyCeZsQqloriPNrPUaVsEYtvAGmgdYPiA1Q",
  authDomain: "wellscan.firebaseapp.com",
  projectId: "wellscan",
});

Vue.use(VueMaterial)

Vue.component('router-link', Vue.options.components.RouterLink);
Vue.component('router-view', Vue.options.components.RouterView);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  firebase,
  render: h => h(App)
}).$mount('#app')
